import { render, staticRenderFns } from "./Zones.vue?vue&type=template&id=88716f60&scoped=true&"
import script from "./Zones.vue?vue&type=script&lang=js&"
export * from "./Zones.vue?vue&type=script&lang=js&"
import style0 from "./Zones.vue?vue&type=style&index=0&id=88716f60&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88716f60",
  null
  
)

export default component.exports